/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="37"
        height="38"
        viewBox="0 0 37 38"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <g
          fill="none"
          transform="translate(.5 .775)"
          fillRule="evenodd">
          <circle
            cx="18.144"
            cy="18.144"
            r="18.144"
            fill="#1570BC"
            className="icon-fill"/>
          <g
            stroke="#FFF"
            className="icon-color"
            strokeWidth="3.456"
            strokeLinecap="square">
            <path d="M18.25 11.54v13.479M25.738 17.885h-15.24"/>
          </g>
        </g>
      </svg>
    );
  }
}

Icon.displayName = 'PlusSignFillIcon';

export default Icon;
